import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import SmoothPicker from 'vue-smooth-picker'
import 'vue-smooth-picker/dist/css/style.css'

import '@/styles/main.css'
import '@/styles/old.css'
import '@/styles/restaurant.css'
import '@/styles/fix-width.css'

import '@/styles/scss/main.scss'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import * as VueGoogleMaps from 'vue2-google-maps'
import VueGtag from "vue-gtag";
import VueAnalytics from 'vue-analytics'
import AsyncComputed from 'vue-async-computed'

import VueI18n from 'vue-i18n'
import langTH from '@/lang/th'
import langEN from '@/lang/en'

import { beforeRoute } from '@/router/beforeRoute'

Vue.use(AsyncComputed)
Vue.use(Element)
Vue.use(SmoothPicker)
Vue.use(VueI18n)
Vue.use(VueGtag, { config: { id: "G-S6X93GKKSD" } })
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD1uNSx_3D3XPys-PDuHTsLm9iHjiB4bDI',
    libraries: 'places'
  },
})

const files = require.context('@/baseComponents', true, /\.vue$/i)
files.keys().map(key => {
  Vue.component(files(key).default.name ? key.split('/').pop().split('.')[0] : '', files(key).default);
})

let lang = localStorage.getItem('fslang')
let locale = 'th'
let messages = { th: langTH }
if (lang === 'en') {
  locale = 'en'
  messages = { en: langEN }
}

export const i18n = new VueI18n({
  locale,
  fallbackLocale: 'th',
  messages
})

const firebaseConfig = {
  apiKey: "AIzaSyCXcHPq2N2-_bV3oN9P0XW2FWJBqdpaxqw",
  authDomain: "foodstory-9c927.firebaseapp.com",
  databaseURL: "https://foodstory-9c927.firebaseio.com",
  projectId: "foodstory-9c927",
  storageBucket: "foodstory-9c927.appspot.com",
  messagingSenderId: "262948598018",
  appId: "1:262948598018:web:fd7aee32e853d9a4afd21b",
  measurementId: "G-CEP29D1GPW"
}

firebase.initializeApp(firebaseConfig)

router.beforeEach((to, from, next) => {
  if (to.meta.skipBeforeEach) return next()
  return beforeRoute(to, from, next)
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js